import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';

import {
  TXTCLI_You_can_make_N0_depositsX_incl_ELL,
  TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_2,
  TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_3,
  TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_4,
  TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_7,
  TXTCLI_You_can_make_Xb_classXXredXXN1_ELL,
  TXTCLI_You_can_make_Xb_classXXredXXN1_ELL_1,
  TXTCLI_You_can_make_Xb_classXXredXXN1_ELL_2,
  TXTCLI_You_can_make_Xb_classXXredXXN2_ELL_3,
  TXTCLI_You_may_make_a_total_of_N0_of__ELL_1
} from './DefaultDepositsInfo.messages.json';

interface Props {
  isSingleTicket: boolean;
  isLastPotentialTicketReward: boolean;
  lastEligibleDepositTime: JSX.Element;
}

const DefaultDepositsInfo: React.FC<Props> = ({
  isSingleTicket,
  lastEligibleDepositTime,
  isLastPotentialTicketReward
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    maxNumberOfDepositsLeft,
    lastAllowedDepositTime,
    maxNumberOfDeposits,
    maxNumTickets,
    maxDaysForDepositLeft
  } = preCashinInfo as PreCashinInfo;

  if (maxDaysForDepositLeft) {
    return (
      <Translation
        {...(maxNumberOfDeposits === maxNumberOfDepositsLeft
          ? TXTCLI_You_can_make_N0_depositsX_incl_ELL
          : TXTCLI_You_may_make_a_total_of_N0_of__ELL_1)}
        values={{
          0: maxNumberOfDepositsLeft,
          1:
            maxNumberOfDeposits === maxNumberOfDepositsLeft
              ? maxDaysForDepositLeft
              : lastEligibleDepositTime,
          2: lastEligibleDepositTime
        }}
      />
    );
  }

  if (isSingleTicket) {
    if (!lastAllowedDepositTime) {
      return isLastPotentialTicketReward ? (
        <Translation
          {...TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_2}
          values={{ 0: maxNumberOfDepositsLeft }}
        />
      ) : (
        <Translation
          {...TXTCLI_You_can_make_Xb_classXXredXXN1_ELL}
          values={{
            0: maxNumTickets,
            1: maxNumberOfDepositsLeft
          }}
        />
      );
    }

    return (
      <Translation
        {...(isLastPotentialTicketReward
          ? TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_3
          : TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_4)}
        values={{
          0: maxNumberOfDepositsLeft,
          1: lastEligibleDepositTime,
          2: maxNumTickets
        }}
      />
    );
  }

  return !lastAllowedDepositTime ? (
    <Translation
      {...(isLastPotentialTicketReward
        ? TXTCLI_You_can_make_Xb_classXXredXXN0_ELL_7
        : TXTCLI_You_can_make_Xb_classXXredXXN1_ELL_1)}
      values={{
        0: isLastPotentialTicketReward ? maxNumberOfDepositsLeft : maxNumTickets,
        1: maxNumberOfDepositsLeft
      }}
    />
  ) : (
    <Translation
      {...(isLastPotentialTicketReward
        ? TXTCLI_You_can_make_Xb_classXXredXXN1_ELL_2
        : TXTCLI_You_can_make_Xb_classXXredXXN2_ELL_3)}
      values={
        isLastPotentialTicketReward
          ? {
              0: lastEligibleDepositTime,
              1: maxNumberOfDepositsLeft
            }
          : {
              0: maxNumTickets,
              1: lastEligibleDepositTime,
              2: maxNumberOfDepositsLeft
            }
      }
    />
  );
};

export default DefaultDepositsInfo;
